import { useFormik } from "formik";
import { useSearchParams } from "react-router-dom";
import { Button } from "../../../components/buttons/button";
import { TextLink } from "../../../components/buttons/textLink";
import { TextInput } from "../../../components/inputs/textInput";
import { HeaderSubheader } from "../../../components/typography/headerSubheader";
import { useForgotPasswordMutation } from "../../../redux/features/auth/auth.api";
import { forgotPasswordSchema } from "../../../validationSchema";

export const ForgotPasswordDetails = ({
  setStep,
}: {
  setStep: (step: number) => void;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [forgotPassword, { isLoading: sendingCode }] =
    useForgotPasswordMutation();

  const {
    values,
    errors,
    isValid,
    touched,
    handleChange,
    handleSubmit,
    handleBlur,
  } = useFormik({
    initialValues: {
      email: searchParams.get("email") ?? "",
    },
    validationSchema: forgotPasswordSchema,
    onSubmit: async (data) => {
      const payload = {
        Email: data.email,
      };

      const resp = await forgotPassword({
        ...payload,
      });

      if (resp.data?.success) {
        setSearchParams({
          email: data.email,
        });
        setStep(2);
      }
    },
  });

  return (
    <div className="w-full">
      <HeaderSubheader
        header="Forgot Password"
        subheader="Kindly provide your email address."
      />

      <form className="mt-6 flex flex-col gap-3" onSubmit={handleSubmit}>
        <TextInput
          type="text"
          name={"email"}
          value={values.email}
          placeholder="Email Address"
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors.email && touched.email ? errors.email : ""}
          hasIcon={false}
        />

        <Button
          text="Continue"
          type="submit"
          disabled={!isValid || sendingCode}
          loading={sendingCode}
          className="w-full mt-5 md:mt-3"
        />

        <p className="w-full mt-1 !text-sm">
          I remember my password.{" "}
          <TextLink to="/auth/sign-in" text="Login" className="" />
        </p>
      </form>
    </div>
  );
};
